import BaseType from "../BaseType";
import AwardLocale from "./AwardLocale";

export default class Award extends BaseType {
  IsNational: boolean = false;
  Locales: AwardLocale[] = [];
}
